// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__1uH03","colMin":"styles_colMin__3FZPZ","colCheckbox":"styles_colCheckbox__390pA"};